import styled from 'styled-components';

import Icon from './Icon';
import Input from './Input';

const FormInput = styled.div`
  position: relative;
  padding: 0;
  margin: 0;
`;

FormInput.Icon = Icon;
FormInput.Input = Input;

export default FormInput;
